import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-[#E5DCC4] bg-[#F5EFDD]">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <span className="font-display text-lg font-semibold text-[#1A2622]">Piece of Cake</span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#7A857F] border-l border-[#D4C9AF] pl-2">LTC</span>
          </div>
          <p className="mt-3 text-sm text-[#5A6660] max-w-md leading-relaxed">Nursing-home ownership and performance data, sourced from public CMS datasets. Built for families, operators, and investors.</p>
        </div>
        <div>
          <h4 className="text-[11px] font-semibold uppercase tracking-wider text-[#2D5F4F] mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-[#3A4A44]">
            <li><Link to="/facilities" className="hover:text-[#1A2622]">Facilities</Link></li>
            <li><Link to="/owners" className="hover:text-[#1A2622]">Owners</Link></li>
            <li><Link to="/chains" className="hover:text-[#1A2622]">Chains</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[11px] font-semibold uppercase tracking-wider text-[#2D5F4F] mb-3">Tools</h4>
          <ul className="space-y-2 text-sm text-[#3A4A44]">
            <li><Link to="/rankings" className="hover:text-[#1A2622]">Rankings</Link></li>
            <li><Link to="/ask" className="hover:text-[#1A2622]">Ask AI</Link></li>
            <li><Link to="/watchlist" className="hover:text-[#1A2622]">Watchlist</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[11px] font-semibold uppercase tracking-wider text-[#2D5F4F] mb-3">Data</h4>
          <ul className="space-y-2 text-sm text-[#3A4A44]">
            <li><a href="https://data.cms.gov" target="_blank" rel="noreferrer" className="hover:text-[#1A2622]">data.cms.gov</a></li>
            <li>Refreshed monthly</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5DCC4]">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
          <p className="text-xs text-[#7A857F]">© 2026 Piece of Cake LTC · Public CMS data · Informational use only.</p>
          <p className="text-xs text-[#7A857F]">Not affiliated with CMS or Medicare.</p>
        </div>
      </div>
    </footer>
  );
}
